import { createApi } from '@reduxjs/toolkit/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const nChatApi = createApi({
  reducerPath: 'nChatApi',
  baseQuery: rtkBaseQuery('/auth/NChat'),
  endpoints: (builder) => ({
    updateChatGroupName: builder.mutation({
      query: (params) => ({
        method: 'PUT',
        url: '/UpdateChatGroupName',
        params,
      }),
    }),
  }),
});

export const {
useUpdateChatGroupNameMutation,
} = nChatApi;
